import _ from 'lodash';

/**
 * intended to be used as a way to differentiate between the Form Designer/Page Designer/Screen Designer modes, to show/hide fields in module editors
 */
const designerTypes = {
  ENTRY_FORM:   'entryForm', //new form designer, when used inside an experience
  LIBRARY_FORM: 'libraryForm', //new form designer, when used in the global library assets
  FOOTER:       'footer', //new form designer, when used in the global library assets
  PAGE:         'page', //macro page designer
  SCREEN:       'screen', //micro screen designer
};

designerTypes.ALL = _.values(designerTypes);

designerTypes.isLibraryFormDesigner = designerType => designerType === designerTypes.LIBRARY_FORM;

designerTypes.isEntryFormDesigner = designerType => designerType === designerTypes.ENTRY_FORM;

designerTypes.isFormDesigner = designerType =>
  designerTypes.isEntryFormDesigner(designerType) || designerTypes.isLibraryFormDesigner(designerType);

designerTypes.isScreenDesigner = designerType => designerType === designerTypes.SCREEN;

designerTypes.isPageDesigner = designerType => designerType === designerTypes.PAGE;

designerTypes.isFooterDesigner = designerType => designerType === designerTypes.FOOTER;

designerTypes.isScreenOrFooterDesigner = designerType =>
  _.includes([designerTypes.FOOTER, designerTypes.SCREEN], designerType);

designerTypes.isLayoutDesigner = designerType =>
  designerTypes.isFormDesigner(designerType) ||
  designerTypes.isScreenDesigner(designerType) ||
  designerTypes.isFooterDesigner(designerType);

export default designerTypes;
